<ziro-fieldset-header [legend]="'tkey;snr.snrprofile.label'">
  <ziro-text fieldId="profileName"></ziro-text>
  <ziro-text fieldId="profileDescription"></ziro-text>
  <ziro-select fieldId="aarCallingSearchSpace"></ziro-select>
  <ziro-select fieldId="callingSearchSpace"></ziro-select>
  <ziro-select fieldId="reroutingCallingSearchSpace"></ziro-select>
  <ziro-select fieldId="userMohAudioSource"></ziro-select>
  <ziro-select fieldId="networkMohAudioSource"></ziro-select>
  <ziro-select fieldId="privacy"></ziro-select>
</ziro-fieldset-header>
